import type {
  LeadDetailResponse,
  LeadDto,
  ListLeadsResponse,
  UpdateLeadInput,
} from "@mvk/shared";
import { apiRequest } from "./client";
import { apiDownload } from "./download";

function leadsQuery(options?: {
  companyId?: string;
  direction?: "inbound" | "outbound" | "all";
  assignedTo?: string | "unassigned";
}): string {
  const params = new URLSearchParams();
  if (options?.companyId) params.set("companyId", options.companyId);
  if (options?.direction && options.direction !== "all") {
    params.set("direction", options.direction);
  }
  if (options?.assignedTo) params.set("assignedTo", options.assignedTo);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export const leadsApi = {
  list(
    eventId: string,
    audience: "visitor" | "admin" = "admin",
    options?: {
      companyId?: string;
      direction?: "inbound" | "outbound" | "all";
      assignedTo?: string | "unassigned";
    },
  ) {
    return apiRequest<ListLeadsResponse>(
      `/events/${eventId}/leads${leadsQuery(options)}`,
      { audience },
    );
  },

  exportCsv(
    eventId: string,
    audience: "visitor" | "admin" = "admin",
    options?: {
      companyId?: string;
      direction?: "inbound" | "outbound" | "all";
      assignedTo?: string | "unassigned";
    },
  ) {
    const companyId = options?.companyId;
    return apiDownload(`/events/${eventId}/leads/export${leadsQuery(options)}`, {
      audience,
      filename: companyId ? `leads-${eventId}-${companyId}.csv` : `leads-${eventId}.csv`,
    });
  },

  get(eventId: string, leadId: string, audience: "visitor" | "admin" = "admin") {
    return apiRequest<LeadDetailResponse>(`/events/${eventId}/leads/${leadId}`, {
      audience,
    });
  },

  update(
    eventId: string,
    leadId: string,
    body: UpdateLeadInput,
    audience: "visitor" | "admin" = "admin",
  ) {
    return apiRequest<LeadDetailResponse>(`/events/${eventId}/leads/${leadId}`, {
      method: "PATCH",
      body,
      audience,
    });
  },
};

export function leadDtoToUiLead(dto: LeadDto) {
  return {
    id: dto.id,
    companyId: dto.companyId,
    eventId: dto.eventId,
    visitorId: dto.visitorId,
    visitorName: dto.visitorName,
    visitorPhone: dto.visitorPhone,
    visitorEmail: dto.visitorEmail,
    visitorCompany: dto.visitorCompany,
    visitorPosition: dto.visitorPosition,
    visitorCity: dto.visitorCity,
    visitorActivityType: dto.visitorActivityType,
    visitorInterestedProducts: dto.visitorInterestedProducts,
    scanType: dto.scanType,
    scanTargetId: dto.scanTargetId,
    scannedAt: dto.scannedAt,
    status: dto.status,
    notes: dto.notes,
    rating: dto.rating,
    tags: dto.tags,
    assignedTo: dto.assignedTo,
    assignedRepName: dto.assignedRepName,
    leadSource: dto.leadSource,
  };
}
